// extracted by mini-css-extract-plugin
export var caption = "newsletter-story-module--caption--4dc6e";
export var caption__lifestyle = "newsletter-story-module--caption__lifestyle--4d532";
export var content = "newsletter-story-module--content--a48c0";
export var content__lifestyle = "newsletter-story-module--content__lifestyle--02cf3";
export var intro = "newsletter-story-module--intro--199e9";
export var lifestyleBody = "newsletter-story-module--lifestyleBody--7946f";
export var lifestyleBody__reverse = "newsletter-story-module--lifestyleBody__reverse--37daf";
export var lifestyleImage = "newsletter-story-module--lifestyleImage--508bf";
export var lifestyleImageWrap = "newsletter-story-module--lifestyleImageWrap--443ba";
export var regionalImage = "newsletter-story-module--regionalImage--f88ec";
export var sectionPartner = "newsletter-story-module--sectionPartner--ac5f8";
export var social = "newsletter-story-module--social--b1414";
export var spin = "newsletter-story-module--spin--d0cde";
export var subject = "newsletter-story-module--subject--5faa7";
export var subject__lifestyle = "newsletter-story-module--subject__lifestyle--86311";
export var title = "newsletter-story-module--title--dc2de";
export var title__lifestyle = "newsletter-story-module--title__lifestyle--2a01f";
export var wrapper = "newsletter-story-module--wrapper--61c41";
export var wrapper__black = "newsletter-story-module--wrapper__black--610a2";
export var wrapper__bloodorange = "newsletter-story-module--wrapper__bloodorange--4c8bb";
export var wrapper__chartruse = "newsletter-story-module--wrapper__chartruse--89f9c";
export var wrapper__cobalt = "newsletter-story-module--wrapper__cobalt--93103";
export var wrapper__emerald = "newsletter-story-module--wrapper__emerald--221c1";
export var wrapper__lifestyle = "newsletter-story-module--wrapper__lifestyle--3a7f8";
export var wrapper__paper = "newsletter-story-module--wrapper__paper--9ba52";
export var wrapper__pink = "newsletter-story-module--wrapper__pink--0bc4d";
export var wrapper__sky = "newsletter-story-module--wrapper__sky--d1fa3";
export var wrapper__white = "newsletter-story-module--wrapper__white--0f1bd";